// extracted by mini-css-extract-plugin
export default {"info_item":"ContactsInfo_info_item__gv1PN","info_item_label":"ContactsInfo_info_item_label__7o9nJ","info_item_content":"ContactsInfo_info_item_content__1liUL"};